import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginPanelComponent } from 'src/app/modules/user-management/components/login-panel/login-panel.component';
import { SecurityQuestionAuthScreenComponent } from
  'src/app/modules/user-management/screens/security-question-auth-screen/security-question-auth-screen.component';
import { LoginScreenComponent } from './modules/user-management/screens/login-screen/login-screen.component';
import { UnkownRouteScreenComponent } from './screens/unkown-route-screen/unkown-route-screen.component';

const routes: Routes = [
  { path: 'login', component: LoginScreenComponent},
  { path: 'login-panel', component: LoginPanelComponent},
  { path: 'login-questions', component: SecurityQuestionAuthScreenComponent},
  {
    path: 'account',
    loadChildren: () => import('src/app/modules/user-management/user-management.module').then(
      m => m.UserManagementModule
    )
  },
  {
    path: 'apo',
    loadChildren: () => import('src/app/modules/apo/apo.module').then(
      m => m.APOModule
    )
  },
  { path: '.aspx',   redirectTo: '/login', pathMatch: 'full' }, // redirect to `login`
  { path: '',   redirectTo: '/login', pathMatch: 'full' }, // redirect to `login`
  { path: '**', pathMatch: 'full', component: UnkownRouteScreenComponent} // Wildcard route for a 404 page
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
